export const SSOProvider: React.FC = ({ children }) => {
  return (
    <>
      {children}
      <div id="sso-layout" />
    </>
  )
}
